import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { contactInfo } from '../mock/reviewsData';

const navLinks = [
  { name: 'Insurance', dropdown: [
    { label: 'Health Insurance', to: '/insurance/health' },
    { label: 'Car Insurance', to: '/insurance/car' },
    { label: 'Bike Insurance', to: '/insurance/bike' },
    { label: 'Life Insurance', to: '/insurance/life' },
    { label: 'Term Insurance', to: '/insurance/term' },
    { label: 'Group Term Insurance', to: '/products/group-term' },
    { label: 'Group Health Insurance', to: '/products/group-health' },
    { label: 'Personal Accident Insurance', to: '/products/personal-accident' },
    { label: 'Home Insurance', to: '/products/home-insurance' },
    { label: 'Workmen Compensation Insurance', to: '/products/workmen-compensation' },
    { label: 'Fire and Burglary Insurance', to: '/products/fire-burglary' },
    { label: 'Marine Insurance', to: '/products/marine-insurance' },
  ]},
  { name: 'Our Other Products', dropdown: [
    { label: 'Sattva Products - Organic Mangoes', to: '/products/sattva-organic-mangoes' },
  ]},
  { name: 'Business Associate', dropdown: [
    { label: 'HDFC Life Insurance', to: '/products/hdfc-life' },
    { label: 'Care Health Insurance', to: '/products/care-health' },
  ]},
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(null);

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <a href="/" className="flex items-center gap-3 shrink-0 group">
            <div className="relative">
              <div className="absolute -inset-1 rounded-2xl bg-gradient-to-br from-emerald-300 to-teal-400 opacity-40 blur-md group-hover:opacity-60 transition-opacity" />
              <div className="relative w-12 h-12 rounded-2xl bg-white ring-2 ring-emerald-100 shadow-md overflow-hidden flex items-center justify-center">
                <img
                  src="/insure_logo.jpeg"
                  alt="InsureRiskFree Solutions"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="leading-tight">
              <div className="text-lg lg:text-xl font-extrabold text-[#0F2A4B] tracking-tight">
                InsureRiskFree <span className="text-[#00B48E]">Solutions</span>
              </div>
              <div className="text-[10px] lg:text-[11px] font-medium text-slate-500 tracking-wide">
                Insurance • Investment • Insight
              </div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <div
                key={link.name}
                className="relative"
                onMouseEnter={() => setActive(link.name)}
                onMouseLeave={() => setActive(null)}
              >
                <button className="flex items-center gap-1 px-4 py-2 text-[15px] font-medium text-slate-700 hover:text-[#00B48E] rounded-lg transition-colors">
                  {link.name} <ChevronDown className={`w-4 h-4 transition-transform ${active === link.name ? 'rotate-180' : ''}`} />
                </button>
                {active === link.name && (
                  <div className="absolute left-0 top-full pt-2 w-56 z-50">
                    <div className="bg-white rounded-xl shadow-lg border border-slate-100 py-2 overflow-hidden">
                      {link.dropdown.map((item) => (
                        <Link key={item.label} to={item.to} className="block px-4 py-2.5 text-sm text-slate-700 hover:bg-emerald-50 hover:text-[#00B48E] transition-colors">
                          {item.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
            <a href="/#contact" className="px-4 py-2 text-[15px] font-medium text-slate-700 hover:text-[#00B48E] rounded-lg transition-colors">Contact</a>
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            {contactInfo.phones.map((phoneItem, index) => (
              <a key={index} href={`tel:${phoneItem.number.replace(/\s+/g, '')}`} className="flex items-center gap-2 text-sm font-medium text-slate-700 hover:text-[#00B48E]">
                <Phone className="w-4 h-4" /> {phoneItem.number}
              </a>
            ))}
          </div>

          <button className="lg:hidden p-2 text-slate-700" onClick={() => setOpen(!open)} aria-label="menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <details key={link.name} className="group">
                <summary className="flex justify-between items-center px-3 py-2.5 text-slate-700 font-medium cursor-pointer rounded-lg hover:bg-slate-50">
                  {link.name} <ChevronDown className="w-4 h-4 group-open:rotate-180 transition-transform" />
                </summary>
                <div className="pl-4 py-1 space-y-1">
                  {link.dropdown.map((item) => (
                    <Link key={item.label} to={item.to} onClick={() => setOpen(false)} className="block px-3 py-2 text-sm text-slate-600 rounded-lg hover:bg-emerald-50">{item.label}</Link>
                  ))}
                </div>
              </details>
            ))}
            {contactInfo.phones.map((phoneItem, index) => (
              <a key={index} href={`tel:${phoneItem.number.replace(/\s+/g, '')}`} className="block px-3 py-2 text-sm text-slate-700 rounded-lg hover:bg-slate-50">
                {phoneItem.number}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
